import script from "./MatomoManager.vue?vue&type=script&lang=js"
export * from "./MatomoManager.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__